import { Component, OnInit } from '@angular/core';
import { SessionSelectors, NotificationsSelectors, BirthdaysService, AuthSelectors } from '@store';
import { Birthdays, getCardLabel, NotificationInfo, Notifications } from '@store/models';
import { map, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BirthdaysAllComponent } from './birthdays/birthdays-all/birthdays-all.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    standalone: false
})

export class DashboardComponent implements OnInit {

    recentClients$ = this.sessionSelector.recentClients$;
    activeNotification$ = this.notificationsSelector.notifications$.pipe(
        map(notifications => notifications ? Object.entries(notifications).filter(([_, value]) => value > 0) : []),
        map(entries => entries.map(entry => ({
            key: entry[0] as keyof Notifications,
            count: entry[1],
            cardLabel: getCardLabel(entry[0] as keyof Notifications),
        } as NotificationInfo)))
    );
    birthdays$ = this.authSelector.loggedIn$.pipe(
        switchMap(loggedIn => {
            if (loggedIn) {
                return this.birthdaysService.getBirthdays();
            } else {
                return of(null);
            }
        })
    );

    constructor(
        private sessionSelector: SessionSelectors,
        private notificationsSelector: NotificationsSelectors,
        private router: Router,
        private birthdaysService: BirthdaysService,
        private ngbModal: NgbModal,
        private authSelector: AuthSelectors,
    ) {}

    ngOnInit() {
        window.scrollTo(0, 0);
    }

    selectClient(kid: number) {
        this.router.navigate(['/clients', kid.toString()]);
    }

    allBirthdays() {
        const birthdayModal = this.ngbModal.open(BirthdaysAllComponent, { size: 'lg' });
        this.birthdaysService.getAllBirthdays().pipe(take(1)).subscribe(
            birthdays => { birthdayModal.componentInstance.birthDays = this.sortBirthdays(birthdays); }
        );
        birthdayModal.result
            .catch(() => {})
            .then(value => {
                if (value) { this.selectClient(value); }
            });
    }

    sortBirthdays(birthdays: Birthdays): Birthdays {
        if (!birthdays.clientsWithBirthday) { birthdays.clientsWithBirthday = []; }
        birthdays.clientsWithBirthday.forEach(
            (data, i) => {
                const bd = new Date(data.birthdate);
                const bdThisYear = new Date(data.birthdayThisYear);
                birthdays.clientsWithBirthday[i].age = bdThisYear.getFullYear() - bd.getFullYear();
            }
        );
        if (!birthdays.spousesWithBirthday) { birthdays.spousesWithBirthday = []; }
        birthdays.spousesWithBirthday.forEach(
            (data, i) => {
                const bd = new Date(data.birthdate);
                const bdThisYear = new Date(data.birthdayThisYear);
                birthdays.spousesWithBirthday[i].age = bdThisYear.getFullYear() - bd.getFullYear();
            }
        );
        return birthdays;
    }

}
